import { Component, input, output } from '@angular/core';

@Component({
  selector: 'yon-pw-quantity-selector',
  standalone: true,
  templateUrl: './paywall-quantity-selector.component.html',
  styleUrl: './paywall-quantity-selector.component.scss'
})
export class PaywallQuantitySelectorComponent {
  quantity = input.required<number>();
  min = input(1);
  max = input(9999);
  step = input(1);
  helper = input('');
  ariaLabel = input('Number of seats');

  quantityChange = output<number>();

  get decDisabled(): boolean {
    return this.quantity() <= this.min();
  }

  get incDisabled(): boolean {
    return this.quantity() >= this.max();
  }

  decrease(): void {
    this.quantityChange.emit(Math.max(this.min(), this.quantity() - this.step()));
  }

  increase(): void {
    this.quantityChange.emit(Math.min(this.max(), this.quantity() + this.step()));
  }

  onTyping(event: Event): void {
    const value = parseInt((event.target as HTMLInputElement).value, 10);
    if (isNaN(value)) {
      return;
    }
    this.quantityChange.emit(Math.max(1, Math.min(this.max(), value)));
  }

  onCommit(event: Event): void {
    const inputEl = event.target as HTMLInputElement;
    const value = parseInt(inputEl.value, 10);
    const next = isNaN(value) ? this.quantity() : Math.max(this.min(), Math.min(this.max(), value));
    // When the corrected value equals the current quantity the [value] binding does not re-render,
    // so an empty or invalid field would keep showing what was typed instead of the seats in use.
    inputEl.value = String(next);
    this.quantityChange.emit(next);
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      (event.target as HTMLInputElement).blur();
    }
  }
}
